import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateWriteoffDetailAction as updateWriteoffDetail } from '../../../../../services/WriteoffService/slice';

export const JustificationNotesField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentWriteoff } = useAppSelector(state => state.writeoff);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateWriteoffDetail({ justificationNotes: event.target.value }));
  };

  return (
    <TextField
      label="Justification Notes"
      value={currentWriteoff?.detail?.justificationNotes || ''}
      onChange={handleChange}
      size="small"
      fullWidth
      multiline
      rows={3}
      placeholder="Enter detailed justification for this writeoff"
      InputProps={{
        sx: {
          alignItems: 'flex-start',
          '& .MuiInputBase-inputMultiline': {
            whiteSpace: 'pre-wrap'
          }
        }
      }}
      InputLabelProps={{
        sx: {
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)'
          }
        }
      }}
    />
  );
};

export default JustificationNotesField;
